import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {ServidorImpressaoService} from "../../services/servidor-impressao.service";
import {ImpressaoService} from "../../services/impressao.service";
import {DialogRef, DialogService} from "@progress/kendo-angular-dialog";
import {ModalConfirmacaoComponent} from "../cad-horariosfuncionamento/modal-confirmacao.component";
import {KendoPopupUtils} from "../../lib/KendoPopupUtils";



@Component({
  selector: 'app-modal-servidor-impressao',
  templateUrl: './modal-servidorimpressao.component.html',
  styleUrls: ['./modal-servidorimpressao.component.scss']
})
export class ModalServidorImpressaoComponent implements OnInit {
  @Input() empresa: any = {}
  @Input() editandoServidor: boolean ;
  @Input()  servidorSelecionado: any = null;
  @Input()   qzInstalado = true;
  @Output() fechouModal = new EventEmitter();
  @Output() salvou = new EventEmitter();

  salvando = false;
  // Novas propriedades para fluxo de servidor-impressora
  modoCriacaoRapidaServidor  = false;
  // Novas propriedades para seleção de impressoras
  impressorasDisponiveis: any[] = [];
  impressorasSelecionadas: any[] = [];
  detalhesImpressoras: any = {};
  carregandoDetalhes = false;
  msgErro: string;
  mensagemSucesso: string;
  conectando = false;
  constructor(    private servidorImpressaoService: ServidorImpressaoService,
                  private impressao: ImpressaoService,   private dialogService: DialogService) {

  }

  ngOnInit(): void {
    this.impressorasSelecionadas = [];
    this.detalhesImpressoras = {};
   // this.modoCriacaoRapidaServidor = false;
    this.modoCriacaoRapidaServidor = !this.servidorSelecionado.id;

    if(!this.modoCriacaoRapidaServidor ){
      // Carregar impressoras já vinculadas
      if (this.servidorSelecionado.impressoras)
        this.impressorasSelecionadas.push(...this.servidorSelecionado.impressoras)


      this.carregueImpressorasDisponiveis();
    }


  }

  carregueImpressorasDisponiveis() {
    let impressorasEmpresa: Array<any> = this.empresa.configImpressao.impressoras;

    this.impressorasDisponiveis = impressorasEmpresa.filter(
      (item: any) => !item.servidorImpressao && item.id);


    this.impressorasSelecionadas.forEach((impressora) => {
      this.impressorasDisponiveis.splice(0, 0, impressora)
    })

    /* if ( this.qzInstalado) {
       this.impressao.listeImpressoras().then((resultado: any) => {
         if (resultado.sucesso) {
           this.impressorasDisponiveis = resultado.data;
           // Filtrar impressoras que não estão vinculadas a outros servidores
           this.filtreImpressorasDisponiveis();
         } else {
           this.erro = 'Houve um erro ao carregar a lista de impressoras: ' + resultado.erro;
         }
       });
     } */
  }

  conectouQzTray(){
    this.qzInstalado = true;
    this.conectando = false;
    this.carregueImpressorasDisponiveis()
  }



  async obtenhaDetalhesImpressora(nomeImpressora: string): Promise<any> {
    if (this.detalhesImpressoras[nomeImpressora]) {
      return this.detalhesImpressoras[nomeImpressora];
    }

    try {
      this.carregandoDetalhes = true;

      // Usar QZ Tray para obter detalhes da impressora
      const detalhes = await this.impressao.obtenhaDetalhesImpressora(nomeImpressora);

      if (detalhes && detalhes.sucesso) {
        this.detalhesImpressoras[nomeImpressora] = detalhes.data;
        return detalhes.data;
      } else {
        // Fallback para informações básicas
        return {
          nome: nomeImpressora,
          status: 'Disponível',
          localizacao: 'Local',
          tipo: 'Impressora Local'
        };
      }
    } catch (erro) {
      console.error('Erro ao obter detalhes da impressora:', erro);
      return {
        nome: nomeImpressora,
        status: 'Erro ao obter detalhes',
        localizacao: 'Desconhecido',
        tipo: 'Impressora Local'
      };
    } finally {
      this.carregandoDetalhes = false;
    }
  }

  toggleImpressoraSelecionada(impressora: string) {
    const index = this.impressorasSelecionadas.indexOf(impressora);
    if (index > -1) {
      this.impressorasSelecionadas.splice(index, 1);
    } else {
      this.impressorasSelecionadas.push(impressora);
    }
  }

 /* filtreImpressorasDisponiveis() {
    // Remover impressoras que já estão vinculadas a outros servidores
    this.impressorasDisponiveis = this.impressorasDisponiveis.filter(imp => {
      // Verificar se a impressora já está vinculada a outro servidor
      const servidorVinculado = this.servidoresImpressao.find(servidor =>
          servidor.impressoras && servidor.impressoras.find(impServidor =>
            impServidor.nome === imp && servidor.id !== this.servidorSelecionado?.id
          )
      );
      return !servidorVinculado;
    });
  } */


  impressoraEstaSelecionada(impressora: string): boolean {
    return this.impressorasSelecionadas.includes(impressora);
  }

  podeSalvarServidor(): boolean {
    if (this.modoCriacaoRapidaServidor) {
      return !!this.servidorSelecionado?.nome;
    }

    return this.servidorSelecionado?.nome &&
      this.impressorasSelecionadas.length > 0;
  }

  async salvarServidor(): Promise<void> {
    if(this.salvando) return
    this.msgErro = null;

    if (!this.podeSalvarServidor()) {
      this.msgErro = 'Nome e pelo menos uma impressora são obrigatórios';
      return;
    }

    // Preparar dados do servidor
    const dadosServidor = {
      ...this.servidorSelecionado,
      impressoras: this.impressorasSelecionadas
    };

    this.salvando =  true;


    this.servidorImpressaoService.salveServidor(dadosServidor).then( async (servidor: any) => {
      this.salvando =  false;
      if (!this.editandoServidor)
        this.mensagemSucesso = 'Servidor criado com sucesso!';
      else
        this.mensagemSucesso = 'Servidor atualizado com sucesso!';

      // Pós-criação rápida: selecionar servidor na combo da impressora
      if (this.modoCriacaoRapidaServidor) {
        this.salvou.emit(servidor)
      } else {
        this.fecheModal();
      //  await this.carregueServidoresImpressao();
      }
    }).catch((err) => {
      this.msgErro = err;
      this.salvando =  false;
    });
  }

  async removerServidor(servidor: any): Promise<void> {

    // Abrir modal de confirmação Kendo
    const windowRef: DialogRef = this.dialogService.open({
      title: 'Confirmar Remoção',
      content: ModalConfirmacaoComponent,
      width: 500,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef);


    windowRef.content.instance.titulo = `Remover Servidor impressao ${servidor.nome}`;
    windowRef.content.instance.mensagem = `Deseja realmente remover o servidor ${servidor.nome}? Esta ação não pode ser desfeita.`;
    windowRef.content.instance.textoConfirmacao = 'Sim, Remover';
    windowRef.content.instance.textoCancelamento = 'Cancelar';
    windowRef.content.instance.tipoConfirmacao = 'danger';

    windowRef.result.subscribe(  (result: any) => {
      if (result && result.confirmado) {
        this.servidorImpressaoService.removaServidor(servidor.id).then(() => {
          this.mensagemSucesso = 'Servidor removido com sucesso!';
          this.fecheModal( true);
          location.reload();
        }).catch((err) => {
          console.error(err)
          alert("Falha ao remover servidor: " + err)
        });
      }
    });
  }

  obtenhaStatusServidor(servidor: any): string {
    if (!servidor.ativo) return 'Inativo';

    // Verificar se está ativo baseado na última atividade
    const agora = new Date();
    const cincoMinutosAtras = new Date(agora.getTime() - 5 * 60 * 1000);

    if (servidor.ultimaAtividade && new Date(servidor.ultimaAtividade) > cincoMinutosAtras) {
      return 'Ativo';
    }

    return 'Inativo (Timeout)';
  }

  obtenhaStatusClass(servidor: any): string {
    if (!servidor.ativo) return 'status-inativo';

    const agora = new Date();
    const cincoMinutosAtras = new Date(agora.getTime() - 5 * 60 * 1000);

    if (servidor.ultimaAtividade && new Date(servidor.ultimaAtividade) > cincoMinutosAtras) {
      return 'status-ativo';
    }

    return 'status-timeout';
  }

  fecheModal(recarregar  = false){
    this.fechouModal.emit({ recarregar: recarregar})
  }


}
